export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1742106852724-0faf505b7797?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwxfHxtdW5uYXIlMjB0ZWElMjBnYXJkZW5zfGVufDB8fHx8MTc4NzQ4NzU3Nnww&ixlib=rb-4.1.0&q=85",
  munnar: "https://images.unsplash.com/photo-1742106852724-0faf505b7797?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwxfHxtdW5uYXIlMjB0ZWElMjBnYXJkZW5zfGVufDB8fHx8MTc4NzQ4NzU3Nnww&ixlib=rb-4.1.0&q=85",
  kanyakumari: "https://images.pexels.com/photos/34411632/pexels-photo-34411632.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  kathakali: "https://images.pexels.com/photos/18832750/pexels-photo-18832750.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  houseboat: "https://images.unsplash.com/photo-1593693411515-c20261bcad6e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwyfHxrZXJhbGElMjBob3VzZWJvYXR8ZW58MHx8fHwxNzg3NDg3NTc2fDA&ixlib=rb-4.1.0&q=85",
  hotel: "https://images.pexels.com/photos/279805/pexels-photo-279805.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

export const WHATSAPP_URL =
  "https://wa.me/919529717726?text=" +
  encodeURIComponent("Hi TrekPanda! I'm interested in the Kerala with Kanyakumari package. Please share details.");

export const MARQUEE_ITEMS = [
  "3-Star Property Stays",
  "Houseboat Experience",
  "Group Trip",
  "Breakfast + Dinner Included",
  "Kathakali Cultural Shows",
  "Train & Flight Options",
  "Pune & Mumbai Departures",
];

export const ITINERARY = [
  {
    day: "01",
    route: "Kochi → Munnar",
    title: "The Climb into Tea Country",
    desc: "Arrive in Kochi, meet your TrekPanda trip leader and the group, and wind straight up into the Western Ghats. Pause at the cascading Cheeyappara and Valara waterfalls before checking into Munnar for the night.",
    tags: ["Kochi Pickup", "Cheeyappara Falls", "Hill Drive"],
    quote: "“Every kilometre uphill, the air cools and the green deepens.”",
  },
  {
    day: "02",
    route: "Munnar — Local Sightseeing",
    title: "A Full Day in the Mist",
    desc: "A slow day among the tea carpets — Mattupetty Dam, Echo Point, the Tata Tea Museum and Pothamedu viewpoint. Cardamom-scented air, hot chai, and hills rolling out in every shade of green.",
    tags: ["Mattupetty Dam", "Echo Point", "Tea Museum"],
  },
  {
    day: "03",
    route: "Munnar → Thekkady",
    title: "Spice Trails & a Night of Kathakali",
    desc: "Descend to Thekkady's spice country. Cruise Periyar Lake spotting elephants along the banks, walk a working spice plantation, and end the night front-row at a thundering Kathakali and Kalaripayattu cultural show.",
    tags: ["Periyar Lake", "Spice Plantation", "Kathakali Show"],
  },
  {
    day: "04",
    route: "Thekkady → Alleppey",
    title: "Drift the Backwaters on a Houseboat",
    desc: "Board a traditional kettuvallam houseboat in Alleppey. Glide past palm-fringed canals, paddy fields and village life as lunch is served on board — the slow, soulful heart of Kerala.",
    tags: ["Houseboat Stay", "Alleppey Canals", "Village Life"],
  },
  {
    day: "05",
    route: "Alleppey → Varkala → Trivandrum",
    title: "Cliff Beaches to the Capital",
    desc: "Chase the coast south to Varkala's famous red cliffs and Papanasam beach, then continue to Trivandrum — the Padmanabhaswamy Temple precincts and an evening in Kerala's capital.",
    tags: ["Varkala Cliff", "Papanasam Beach", "Trivandrum"],
    quote: "“Red cliffs, golden sand, and the Arabian Sea's evening show.”",
  },
  {
    day: "06",
    route: "Trivandrum → Kanyakumari",
    title: "Where Three Seas Become One",
    desc: "Cross into the very tip of India. Ferry out to the Vivekananda Rock Memorial and Thiruvalluvar Statue, then watch the sun sink into the Triveni Sangam — where the Bay of Bengal, Indian Ocean and Arabian Sea meet.",
    tags: ["Vivekananda Rock", "Triveni Sangam", "Sunset Point"],
  },
  {
    day: "07",
    route: "Kanyakumari → Kochi — Departure",
    title: "Sunrise, Then Homeward",
    desc: "Wake early for the famous Kanyakumari sunrise over the confluence. After a final group breakfast, drive back to Kochi with people who started as strangers and leave as family. Drop at Kochi — trip ends.",
    tags: ["Sunrise", "Group Breakfast", "Kochi Drop"],
    quote: "“The trip ends; the group chat never does.”",
  },
];

export const KEY_ATTRACTIONS = [
  "Drift the Alleppey backwaters on a traditional kettuvallam houseboat",
  "Watch the sun set where three seas meet at Kanyakumari's Triveni Sangam",
  "Walk through Munnar's mist-clad tea gardens and viewpoints",
  "Front-row Kathakali & Kalaripayattu cultural night in Thekkady",
  "Cliff-side evening and cafe hopping at Varkala beach",
  "Ferry out to the Vivekananda Rock Memorial & Thiruvalluvar Statue",
];

export const ROUTE_CHIPS = ["Kochi", "Munnar", "Thekkady", "Alleppey", "Varkala", "Trivandrum", "Kanyakumari"];

export const PRICING = [
  {
    id: "kochi-to-kochi",
    badge: "Every Sunday",
    title: "Kerala with Kanyakumari | Kochi to Kochi",
    duration: "6 Nights 7 Days",
    image: IMAGES.houseboat,
    chips: ["Stay", "Breakfast + Dinner", "Sightseeing", "Local Transport", "Trip Captain", "Cultural Shows"],
    price: "₹21,000",
    suffix: "+ 5% GST",
    schedule: "Every Sunday from Kochi · ends Saturday",
    batches: "sundays",
    note: "Join the group directly at Kochi — perfect if you're arranging your own travel to Kerala.",
  },
  {
    id: "flight",
    badge: "Limited Batches",
    title: "Kerala with Kanyakumari | Ex-Pune / Mumbai by Flight",
    duration: "6 Nights 7 Days",
    image: IMAGES.kanyakumari,
    chips: ["Stay", "Breakfast + Dinner", "Sightseeing", "Local Transport", "Trip Captain", "Cultural Shows", "Flights"],
    price: "₹34,000",
    suffix: "+ taxes",
    schedule: "27 Sept + every Sunday in Dec · Sun–Sat",
    batches: ["27 Sep", "6 Dec", "13 Dec", "20 Dec", "27 Dec"],
    note: "Return flights from Pune or Mumbai included — the fastest way to join the group.",
  },
  {
    id: "train",
    badge: "Best Value",
    title: "Kerala with Kanyakumari | Ex-Pune / Mumbai by Train",
    duration: "9 Nights 10 Days",
    image: IMAGES.munnar,
    chips: ["Stay", "Breakfast + Dinner", "Sightseeing", "Local Transport", "Trip Captain", "Cultural Shows", "Trains"],
    price: "₹23,000",
    suffix: "+ taxes",
    schedule: "Every Friday from Pune & Mumbai · ends Sunday",
    batches: "fridays",
    note: "Scenic rail journey down the Konkan coast with the whole group — a trip before the trip.",
  },
];

export const INCLUSIONS = [
  "3-star property stays on twin/triple sharing",
  "Daily breakfast + dinner",
  "Kathakali & Kalaripayattu cultural shows",
  "Experienced TrekPanda group trip leader",
  "All local transfers in comfortable AC vehicles",
  "Kanyakumari Vivekananda Rock ferry",
  "All sightseeing as per itinerary",
];

export const EXCLUSIONS = [
  "5% GST & applicable taxes",
  "Alleppey houseboat stay (available at additional cost)",
  "Lunches and snacks en route",
  "Flight / train tickets (unless booked in package)",
  "Personal expenses, shopping & tips",
  "Entry fees not mentioned in inclusions",
  "Any activity not listed in the itinerary",
];

export const REVIEWS = [
  {
    name: "Jiya Jain",
    batch: "Kerala with Kanyakumari Batch",
    text: "Kerala with TrekPanda was an experience to remember! Aditya, our captain, was excellent and guided us throughout with great energy and professionalism. Munnar's tea and flower gardens, Thekkady's jungle safari, Alleppey's serene backwaters and Varkala's beautiful landscapes made every destination special. The perfect mix of adventure, nature and relaxation!",
  },
  {
    name: "Ronil Deshmukh",
    batch: "Kerala Backpacking Batch",
    text: "Just finished an incredible Kerala backpacking trip with TrekPanda and absolutely loved it! Siddharth was a fantastic captain and kept everything well organised. From elephant rides and jungle safaris to shikara rides, mangrove boat rides and Munnar's gorgeous tea gardens, there was something exciting every day. Definitely one of my most memorable trips!",
  },
  {
    name: "Sneha Kulkarni",
    batch: "Kochi to Kochi Batch",
    text: "My first group trip ever and I'm already planning the next one. The houseboat afternoon and the Kanyakumari sunrise were pure magic. Everything was so well organised that all we had to do was show up and have fun.",
  },
  {
    name: "Omkar Patil",
    batch: "27th Sept Flight Batch",
    text: "From Pune airport to the tip of India, everything ran like clockwork. Great stays, great food, even greater company. The cultural night in Thekkady alone was worth the trip.",
  },
];

export const FAQS = [
  {
    q: "How do I join from Pune or Mumbai?",
    a: "You have three options. Fly with our flight departures on 27th September or any Sunday in December — 6th, 13th, 20th, 27th (₹34,000 + taxes), take the train departing every Friday from Pune and Mumbai (starts at ₹23,000 + taxes), or make your own way and join the group directly in Kochi — departures from Kochi happen every Sunday.",
  },
  {
    q: "Is the houseboat stay included?",
    a: "The Alleppey houseboat experience is available as part of the package. You'll drift the backwaters on a traditional kettuvallam with meals served on board. Confirm your houseboat preference while booking and our team will lock it in.",
  },
  {
    q: "What kind of hotels do we stay in?",
    a: "Clean, comfortable 3-star properties on twin or triple sharing at every halt — Kochi, Munnar, Thekkady and Kanyakumari — plus the Alleppey houseboat option. Breakfast and dinner are included every day.",
  },
  {
    q: "Is this a group trip? Who travels with us?",
    a: "Yes — this is a classic TrekPanda group trip with an experienced trip leader, like-minded travellers from Pune and Mumbai, and a fixed, well-paced itinerary. Solo travellers, couples and friend groups all join.",
  },
  {
    q: "How do I book my seat?",
    a: "Fill the enquiry form on this page or ping us directly on WhatsApp at 95297 17726. Our team will share the booking link, payment steps and a detailed trip brief. Seats are limited per departure and fill fast.",
  },
];
